/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import { React, PT, fetchApi, connect } from '@gasbuddy/react';
import { Modal, Header, Form, Button, Icon, Message, List } from 'semantic-ui-react';

class BaseChangeNameModal extends React.Component {
  state = {}

  callApi = () => {
    const { first, last } = this.state;
    const { accountId, instrumentId } = this.props;
    this.setState({ saving: true }, async () => {
      const { body, status, error } = await fetchApi({
        url: `/payments/instrument/${accountId}/${instrumentId}/set-name`,
        catchErrors: true,
        body: { first, last },
      });
      if (error || status !== 200) {
        this.setState({ error: body || error, saving: false });
      } else {
        this.setState({ opened: false, error: null, saving: false });
      }
    });
  }

  render() {
    const { opened, error, saving } = this.state;
    return (
      <Modal
        open={opened}
        trigger={<Button onClick={() => this.setState({ opened: true })}>Change Name on Card</Button>}
      >
        <Header icon="attention" content="Change Name on Card" />
        <Modal.Content>
          {error
            && (
            <Message negative>
              <Message.Content>
                <List>
                  <List.Header>Cannot change name on card:</List.Header>
                  {(error.log || []).map(l => (
                    <List.Item>
                      {l.message}
                    </List.Item>
                  ))}
                </List>
              </Message.Content>
            </Message>
            )
          }
          {!error && (
            <Message>
              After changing the name using this tool, if a card is shipped
              to them it should have the new name on it.
            </Message>
          )
          }
          <Form>
            <Form.Input
              fluid
              label="First Name"
              placeholder="John"
              onChange={(e, { value }) => this.setState({ first: value })}
            />
            <Form.Input
              fluid
              label="Last Name"
              placeholder="Doe"
              onChange={(e, { value }) => this.setState({ last: value })}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
            Cancel
          </Button>
          <Button loading={saving} basic color="blue" onClick={this.callApi}>
            <Icon name="eye" />
            {' '}
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

BaseChangeNameModal.propTypes = {
  accountId: PT.number,
  instrumentId: PT.number,
};

BaseChangeNameModal.defaultProps = {
  instrumentId: 0,
  accountId: 0,
};

export const ChangeNameModal = connect(() => {})(BaseChangeNameModal);
